import google from './google'

export default google
